import { Fragment, useEffect, useState } from "react";
import "../../../assets/scss/pages/track/all-tracks.scss";
import { Select } from "../../../components/widgets";
import {
  getMoods,
  getSearchTrackList,
  getTempos,
  isExistFile,
} from "../../../actions/user";
import useAuth from "../../../hooks/useAuth";
import { sortByList } from "./contents";
import SearchTrack from "../../../components/tracks/all-tracks/SearchTrack";
import { useDispatch } from "react-redux";
import TrackTable from "../../../components/tracks/all-tracks/TrackTable";
import TrackView from "../../../components/tracks/all-tracks/TrackView";
import { useNavigate } from "react-router-dom";
import { LoadingWidget } from "../../../components/widgets/loading";
import { useSelector } from "react-redux";
import { StoreState } from "../../../types/models/store";
import AnalyseForm from "../../../components/tracks/all-tracks/AnalyseForm";
import { IconCheckCircle } from "../../../assets/images/cugate";
import { Genre } from "../../../actions";

interface Props {
  mode: "normal" | "select" | "my-track";
  onSelect?: (tracks: any[]) => any;
}

export const AllTracksPage: React.FC<Props> = (props: Props) => {
  const { user } = useAuth() as any;
  const { track_filter } = useSelector((state: StoreState) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [genreList, setGenreList] = useState<any>([]);
  const [moodList, setMoodList] = useState<any>([]);
  const [tempoList, setTempoList] = useState<any>([]);
  const [loading, setLoading] = useState("");
  const [moreLoading, setMoreLoading] = useState(false);
  const [fileExist, setFileExist] = useState<any>([]);
  const defaultDataList = {
    pagination: {
      page: 0,
      pages: 0,
      size: 10,
      total: 0,
    },
    isLoaded: false,
    list: [],
    filter: {
      artist: -1,
      composer: -1,
      tempo: -1,
      genre: -1,
      mood: -1,
      isMyPage: false,
    },
  };
  const [trackSearch, setTrackSearch] = useState<any>(defaultDataList);
  const [timer, setTimer] = useState<any>();

  useEffect(() => {
    if (user && user.profile) {
      getMoods().then((data) => {
        setMoodList(data);
      });
      Genre.all().then((data) => {
        setGenreList(data);
      });
      getTempos().then((data) => {
        setTempoList(data);
      });
    }
  }, [user]);

  useEffect(() => {
    clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        if (track_filter.isMyPage !== null) handleSearch();
      }, 500)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [track_filter]);

  const handleReset = () => {
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        artist: [],
        composer: [],
        tempo: [],
        genre: [],
        mood: [],
        keyword: "",
      },
    });
    setTrackSearch(defaultDataList);
  };

  const calcPhysicalFile = async (list: any = []) => {
    let fs = [];
    for (var i = 0; i < list.length; i++) {
      try {
        fs[i] = 0;
        if (list[i].file_info.id) {
          let res = await isExistFile(list[i].file_info.id);
          if (res) {
            if (res) fs[i] = 1;
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    setFileExist(fs);
  };

  const handleSearch = () => {
    if (loading !== "") return;
    setLoading("tracks");
    getSearchTrackList({
      pagination: defaultDataList.pagination,
      filter: {
        ...track_filter,
        ...(props.mode === "my-track" ? { myTrack: true } : {}),
      },
    })
      .then(async (data) => {
        setLoading("");
        data.result.isLoaded = true;
        setTrackSearch(data.result);
        await calcPhysicalFile(data.result.list);
      })
      .catch((err) => {
        console.log(err);
        setLoading("");
      });
  };

  const handleMore = () => {
    if (loading !== "") return;
    let data = trackSearch;
    data.pagination.page++;
    setMoreLoading(true);
    getSearchTrackList({
      pagination: data.pagination,
      filter: track_filter,
    })
      .then((res) => {
        data.pagination = res.result.pagination;
        res.result.list?.map((r: any) => data.list.push(r));
        setTrackSearch({ ...trackSearch, ...data });
        setMoreLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setMoreLoading(false);
      });
  };

  const handlePage = (page: number) => {
    if (loading !== "") return;
    let data = trackSearch;
    data.pagination.page = page;
    setMoreLoading(true);
    setFileExist(Array(data.pagination.size).fill(0));
    getSearchTrackList({
      pagination: data.pagination,
      filter: track_filter,
    })
      .then(async (res) => {
        setMoreLoading(false);
        setTrackSearch(res.result);
        await calcPhysicalFile(res.result.list);
      })
      .catch((err) => {
        console.log(err);
        setMoreLoading(false);
      });
  };

  const handleKeyword = (e: any) => {
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        keyword: e.target.value,
      },
    });
  };

  const handleTrackDetail = (item: any) => {
    // dispatch({
    //   type: "SET_TRACK_SELECT",
    //   payload: item,
    // });
    window.open(`/dashboard/track/${item.id}&${item.file_info.id}`);
    // navigate(`/dashboard/track/${item.id}&${item.file_info.id}`);
  };

  const handleSortBy = (val: any) => {
    if (loading !== "") return;
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        sort_by: val,
      },
    });
  };

  const gotoEditTrack = (trackInfo: any) => {
    navigate(`/track/edit/${trackInfo.id}`);
  };

  const gotoDuplicateTrack = (trackInfo: any) => {
    navigate(`/track/duplicate/${trackInfo.id}`);
  };

  return (
    <div className={"page page-all-tracks show"}>
      <SearchTrack
        data={{
          loading: loading,
          genreList:
            trackSearch.filter.genre === -1
              ? genreList
              : genreList.filter(
                (g: any) => trackSearch.filter.genre.indexOf(g.id) !== -1
              ),
          genreCount: genreList.length,
          moodList:
            (trackSearch?.filter?.mood === -1 || trackSearch.filter.mood.length === 0)
              ? moodList
              : moodList.filter(
                (g: any) => trackSearch.filter.mood.indexOf(g.id) !== -1
              ),
          moodCount: moodList.length,
          tempoList:
            trackSearch.filter.tempo === -1
              ? tempoList
              : tempoList.filter(
                (g: any) => trackSearch.filter.tempo.indexOf(g.id) !== -1
              ),
          tempoCount: tempoList.length,
          handleSearch: handleSearch,
          handleReset: handleReset,
          filtered_artist_list: trackSearch.filter.artist,
          filtered_composer_list: trackSearch.filter.composer,
        }}
      />
      {props.mode === "normal" && <AnalyseForm />}
      <div className="row">
        <div className={"col-sm-12 content-wrapper tracks"}>
          <div className="search-component search-form">
            <div className="container uk-container-large">
              <div className="bg-white border border-white rounded d-flex justify-content-between align-items-center">
                <input
                  placeholder="Search tracks"
                  className="border border-white form-control search-track-input"
                  onChange={handleKeyword}
                  value={track_filter.keyword}
                />
                <img
                  src="/imgs/search.svg"
                  className="me-2 py-2 focus"
                  alt=""
                  onClick={handleSearch}
                />
              </div>
            </div>
          </div>
          {loading === "tracks" ? (
            <div className="container uk-container-large content-body">
              <LoadingWidget />
            </div>
          ) : (
            <Fragment>
              <div className="container uk-container-large content-header d-flex justify-content-between">
                {trackSearch.pagination.total ? (
                  <div className="sort-by-header d-flex">
                    <label className="d-flex align-items-center fw-bold fs-5 uk-blue-medium">
                      Sort By:{" "}
                    </label>
                    <Select
                      items={sortByList}
                      width="180px"
                      textColor="var(--color-blue-light)"
                      color="#1bc3cff9"
                      selectColor="white"
                      value={track_filter.sort_by}
                      onChange={handleSortBy}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="status-header">
                  <span className="fw-bold fs-4 uk-blue-medium">
                    Found{" "}
                    {loading !== "" ? "..." : trackSearch.pagination.total}{" "}
                    results
                  </span>
                </div>
              </div>
              <div className="container uk-container-large content-body">
                {track_filter.sort_by === "played_ranking" ||
                  track_filter.sort_by === "played_count" ? (
                  <TrackView
                    data={{
                      trackSearch: trackSearch,
                      handleMore: handleMore,
                      moreLoading: moreLoading,
                      handleTrackDetail: handleTrackDetail,
                      tempoList: tempoList,
                      genreList: genreList,
                      moodList: moodList,
                      formData: track_filter,
                    }}
                  />
                ) : trackSearch.list?.length ? (
                  <TrackTable
                    data={{
                      trackSearch: trackSearch,
                      setTrackSearch: setTrackSearch,
                      handlePage: handlePage,
                      moreLoading: moreLoading,
                      handleTrackDetail: handleTrackDetail,
                      tempoList: tempoList,
                      genreList: genreList,
                      moodList: moodList,
                      fileExist: fileExist,
                      onClickPlus: gotoDuplicateTrack,
                      onClickEdit: gotoEditTrack,
                    }}
                  />
                ) : (
                  <></>
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {props.mode === "select" && (
        <div
          className="green-button tw-cursor-pointer animation-zoom"
          onClick={() => {
            if (props.onSelect) {
              props.onSelect(
                trackSearch.list.filter((item: any) => item.checked)
              );
            }
          }}
        >
          <IconCheckCircle />
        </div>
      )}
    </div>
  );
};
